import { reactQueryUtils } from "@lib/react-query";
import moment from "moment";
import { analyticsApi, track } from "@/features/analytics";
import { accountApi, type TAccount } from "@/shared/services";

export const validateTimestampVisit = (account: TAccount) => {
  const { timestamps = {} } = account;
  const now = moment().toISOString();
  const createdAt = moment(account.createdAt).toISOString();
  if (moment(createdAt).isBefore("2025-01-22")) return;

  // Check for 2nd day visit - only track if user visits within 2-7 days
  const dayAfterCreation = moment(createdAt).add(1, "day").toISOString();
  const weekAfterCreation = moment(createdAt).add(1, "week").toISOString();
  if (
    moment(now).isAfter(dayAfterCreation) &&
    moment(now).isBefore(weekAfterCreation) &&
    !timestamps.secondDayVisit
  ) {
    track("2nd day visit", {});
    timestamps.secondDayVisit = now;
    accountApi.updateTimestamp("secondDayVisit");
  }

  // Check for 2nd week visit - only track if user visits within 7-30 days
  const monthAfterCreation = moment(createdAt).add(1, "month").toISOString();
  if (
    moment(now).isAfter(weekAfterCreation) &&
    moment(now).isBefore(monthAfterCreation) &&
    !timestamps.secondWeekVisit
  ) {
    track("2nd week visit", {});
    timestamps.secondWeekVisit = now;
    accountApi.updateTimestamp("secondWeekVisit");
  }

  // Check for 2nd month visit - track if user visits after 30 days
  if (moment(now).isAfter(monthAfterCreation) && !timestamps.secondMonthVisit) {
    track("2nd month visit", {});
    timestamps.secondMonthVisit = now;
    accountApi.updateTimestamp("secondMonthVisit");
  }

  postTrialVisitDate(account);
  reactQueryUtils.setQueryData(["account"], (old: TAccount) => {
    if (!old) return old;
    return {
      ...old,
      timestamps,
    };
  });
};

const postTrialVisitDate = async (account: TAccount) => {
  if (account.plan !== "trial") return;
  const now = moment(new Date()); //todays date
  const end = moment(account.trialEnd); // another date
  const duration = moment.duration(end.diff(now));
  const days = duration.asDays();
  const isCreatedAfterApril26 =
    new Date(account.createdAt).getTime() >
    new Date("2022-04-26T00:00:00.000+00:00").getTime();
  if (days > 0 || !isCreatedAfterApril26) return;
  accountApi.postTrialVisitDate();
  const date = moment(new Date()).utc().startOf("day");
  analyticsApi.postHubspotProperty({ post_trial_visit_date: date.valueOf() });
  analyticsApi.postHubspotEvent("post trial visit", {
    date: date.format("DD/MM/YYYY hh:mm"),
  });
};
